import React, { useState, useCallback } from "react";

import { ToastContainer, toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import Notification from "./Notification";
import useStyles from "./styles";
import { useI18n } from "../../providers/I18n/I18n";

export default function useNotification() {
  const { t } = useI18n();
  const classes = useStyles();
  const [, setErrorToastId] = useState(null);
  //   const [message, setMessage] = useState("");
  //   const [notificationType, setNotificationType] = useState("");
  function CustomNotificationContainer() {
    return (
      <ToastContainer
        toastClassName={classes.toastClassName}
        className={classes.toastsContainer}
        bodyClassName={classes.bodyClassName}
        closeButton={<CloseButton className={classes.notificationCloseButton} />}
        closeOnClick={false}
      />
    );
  }

  function CloseButton({ closeToast, className }) {
    return <CloseIcon className={className} onClick={closeToast} />;
  }

  const showNotification = useCallback(
    async (notificationType, message, disableAutoClose = false) => {
      const sendNotification = (componentProps, options) => {
        return toast(
          <Notification
            {...componentProps}
            shadowless={true}
            variant="contained"
            className={classes.notificationComponent}
          />,
          options,
        );
      };
      let componentProps, notificationClass;

      // if (errorToastId && notificationType === "error") return;

      switch (notificationType) {
        case "success":
          componentProps = {
            type: "success",
            message: message,
            // variant: "contained",
            color: "success",
          };
          notificationClass = classes.notificationSuccess;
          break;
        case "warning":
          componentProps = {
            type: "warning",
            message: message,
            // variant: "contained",
            color: "warning",
          };
          notificationClass = classes.notificationWarning;
          break;
        case "danger":
        case "error":
          componentProps = {
            type: "danger",
            message: t(message),
            variant: "contained",
            color: "primary",
            // extraButton: "Resend",
            // extraButtonClick: () => {
            //   alert("hi");
            // },
          };
          notificationClass = classes.notificationDanger;
          break;
        case "smsSuccess":
          componentProps = {
            type: "smsSuccess",
            message: message.message,
            messageId: message.messageId,
            // variant: "contained",
            color: "success",
          };
          notificationClass = classes.notificationSuccess;
          break;
        default:
          componentProps = {
            type: "info",
            message: message,
            // variant: "contained",
            color: "success",
          };
          notificationClass = classes.notificationInfo;
      }

      const toastId = sendNotification(componentProps, {
        position: toast.POSITION.TOP_RIGHT,
        progressClassName: classes.progress,
        onClose: notificationType === "danger" && (() => setErrorToastId(null)),
        className: notificationClass,
        autoClose: disableAutoClose ? 60000 : 5000,
      });

      if (notificationType === "danger") setErrorToastId(toastId);
    },
    [
      classes.notificationComponent,
      classes.progress,
      classes.notificationInfo,
      classes.notificationDanger,
      classes.notificationWarning,
      classes.notificationSuccess,
      t,
    ],
  );
  return {
    showNotification,
    CustomNotificationContainer,
    // setMessage,
    // setNotificationType,
  };
}
